export const getRole = () => {
  const user = JSON.parse(localStorage.getItem('UserDetail'));

 
  const allowedRoles = ['admin', 'distributor', 'dealer', 'agent'];

  if (user?.role && allowedRoles.includes(user.role.toLowerCase())) {
    return user.role.toLowerCase() ;
  }

  return 'guest'; // fallback
};
